<div class="tdo-note-dialog-main" data-cy="note-builder-container">
  <div style="width: 100%;" *ngIf="isLoading" data-cy="note-builder-loading"><app-tdo-progress-spinner></app-tdo-progress-spinner></div>
  <div *ngIf="!isLoading" class="tdo-note-dialog-nav" data-cy="note-builder-nav">
    <div style="display: flex; flex-direction: column; height: 100%;" data-cy="note-builder-nav-content">
      <div style="flex-basis: fit-content; background-color: rgba(0,0,0,0.05); border-top-left-radius: 5px; padding-bottom: 4px;" data-cy="note-builder-nav-header">
        <div style="display: flex; margin-top: 12px; margin-bottom: 3px; margin-right: 2px;" data-cy="note-builder-nav-actions">
          <span style="flex: 1;"></span>
          <mat-icon matTooltip="Delete selected template" style="flex-basis: fit-content; margin-right: 5px; cursor: pointer;" (click)="onDeleteNoteSetClick()" data-cy="note-builder-delete-set-button">delete</mat-icon>
          <mat-icon matTooltip="Add new template" style="flex-basis: fit-content; margin-right: 3px; cursor: pointer;" (click)="onNewNoteSetClick()" data-cy="note-builder-add-set-button">add_circle_outline</mat-icon>
        </div>
      </div>
      <div class="tdo-note-dialog-nav-list" cdkDropList style="flex: 1; overflow-y: auto; margin-top: 2px; margin-bottom: 2px;" (cdkDropListDropped)="sectionDrop($event)" data-cy="note-builder-set-list">
        <ng-container *ngFor="let noteSet of dataNoteSets">
          <div
            class="tdo-note-dialog-nav-list-item"
            [ngClass]="{'tdo-note-dialog-nav-list-item-selected': isNoteSetSelected(noteSet)}"
            style="text-align: right;"
            (click)="onDataNoteSetClick(noteSet)"
            cdkDrag
            (cdkDragStarted)="onNoteSetDragStarted($event, noteSet)"
            (cdkDragEnded)="onNoteSetDragEnded($event)"
            data-cy="note-builder-set-item"
          >
            <div style="width: 100%; padding-right: 6px;" data-cy="note-builder-set-name">
              {{noteSet?.NoteSetName}}
            </div>
          </div>
        </ng-container> 
      </div>
    </div>
  </div>
  <div *ngIf="!isLoading" class="tdo-note-dialog-content" data-cy="note-builder-content">
    <div style="display: flex; flex-basis: 20px;" data-cy="note-builder-title-row">
      <div class="tdo-note-dialog-nav-selection-title" data-cy="note-builder-title-input-container">
        <input (appInputFinished)="onNoteSetEditInputFinished($event)" [(ngModel)]="selectedDataNoteSet.NoteSetName" data-cy="note-builder-title-input">
      </div>
      <div style="flex-basis: 100px; color: var(--tdo-primary); text-align: right" data-cy="note-builder-add-note-container">
        <span style="position: relative; top: 2px; right: -6px;"><mat-icon matTooltip="Add new note" style="flex-basis: fit-content; margin-right: 3px; cursor: pointer;" (click)="onNewNoteClick()" data-cy="note-builder-add-note-button">add_circle_outline</mat-icon></span>
      </div>
    </div>
    <div class="tdo-note-dialog-content-area" style="flex: 1; overflow-y: hidden; padding: 7px 3px 6px 3px;" data-cy="note-builder-notes-container">
      <div class="tdo-note-dialog-note-list" cdkDropList style="height: 100%; flex: 1; overflow-y: auto;" (cdkDropListDropped)="noteDrop($event)" data-cy="note-builder-notes-list">
        <ng-container *ngFor="let note of selectedPredefinedNotes">
          <div
            *ngIf="isEditableNote(note); else nonEditable"
            class="tdo-note-dialog-editable-note"
            (appInputFinished)="onEditableNoteInputFinished($event)"
            (appClickOutside)="onEditableNoteClickOutside(note)"
            data-cy="note-builder-editable-note"
          >
            <input [(ngModel)]="note.NoteTemplate" data-cy="note-builder-note-edit-input">
          </div>
          <ng-template #nonEditable>
            <div
              class="tdo-note-dialog-note-list-item"
              [ngClass]="{'tdo-note-dialog-note-list-item-selected': isNoteSelected(note)}"
              style="display: flex; text-align: left; margin-bottom: 1px;"
              cdkDrag
              (click)="onNoteClick(note)"
              (cdkDragStarted)="onNoteDragStarted($event, note)"
              (cdkDragEnded)="onNoteDragEnded($event)"
              data-cy="note-builder-note-item"
            >
              <div style="width: 100%; padding-right: 6px; flex: 1;" data-cy="note-builder-note-text">
                {{note.NoteTemplate}}
              </div>
              <div class="tdo-note-dialog-note-list-item-buttons" style="flex-basis: 16px; max-height: 16px;" data-cy="note-builder-note-actions">
                <span style="position: relative; top: -1px;">
                  <mat-icon class="mat-note-dialog-list-item-buttons" matTooltip="Edit" (click)="onEditNoteClick(note)" data-cy="note-builder-edit-note-button">edit</mat-icon>
                </span>
                <span style="position: relative; top: -1px;">
                  <mat-icon class="mat-note-dialog-list-item-buttons" matTooltip="Delete" (click)="onDeleteNoteClick(note)" data-cy="note-builder-delete-note-button">delete</mat-icon>
                </span>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <div class="tdo-note-dialog-content-area" style="flex-basis: 120px; max-height: 120px; overflow-y: hidden;" data-cy="note-builder-output-container">
      <textarea [(ngModel)]="noteData" style="outline: unset; border: unset; min-height: 100%; width: 100%; resize: none; overflow-x: hidden; overflow-y: auto;" data-cy="note-builder-output-textarea"></textarea>
    </div>
    <div style="text-align: right; flex-basis: fit-content; margin-top: 6px; margin-bottom: 8px;" data-cy="note-builder-actions">
      <button class="tdo-button tdo-close" mat-button style="margin-right: 10px;" (click)="onCancel()" data-cy="note-builder-cancel-button">Cancel</button>
      <button [disabled]="noteData.length == 0" class="tdo-button tdo-save" (click)="onSave()" data-cy="note-builder-save-button">Save</button>
    </div>
  </div>
</div>
